import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import BlogList from "./BlogList";

const BlogListSection = () => {
  return (
    <section className="py-5 ">
      <Container>
        <div className="d-flex justify-content-center">
          <div className="section-title ">
            <h2 className="text-anime">Blogs</h2>
          </div>
        </div>
        <Link to="/view/all/blogs" className="d-flex justify-content-end mb-1">
          <Button variant="primary">View All</Button>
        </Link>
        <BlogList />
      </Container>
    </section>
  );
};

export default BlogListSection;